import type { AreaHeat, DeskHeat, MeetingRoomHeat } from "@features/reporting/services/OfficeHeatMapService";
import { formatPercent, heatBin } from "./heatScale";
import type { HeatTooltipContent } from "./HeatTooltip";

// Days booked out of the working days in the range, as in the desk utilisation report
export function deskRatio(desk: DeskHeat, daysInRange: number): number | undefined {
  return daysInRange > 0 ? desk.usage / daysInRange : undefined;
}

// People in the area against its capacity on every working day
export function areaRatio(area: AreaHeat, daysInRange: number): number | undefined {
  return area.capacity > 0 && daysInRange > 0 ? area.usage / (area.capacity * daysInRange) : undefined;
}

// Booked hours against an 8-hour working day, as in the meeting room usage report
export function roomRatio(room: MeetingRoomHeat): number {
  return room.utilizationPercentage / 100;
}

export function describe(label: string, ratio: number | undefined, detail?: string): string {
  return [label, formatPercent(ratio), detail].filter(Boolean).join(', ');
}

export function tooltipContent(label: string, ratio: number | undefined, detail?: string): HeatTooltipContent {
  const used = ratio === undefined ? 'No capacity set' : `${formatPercent(ratio)} used`;
  return {title: label, lines: detail ? [used, detail] : [used], bin: heatBin(ratio)};
}
